import type {
	InsightObjectAttribute,
	DefaultAttribute,
} from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-attribute.tsx';
import { matchInsightObjectAttribute } from '@atlassian/jira-servicedesk-insight-object-types/src/common/utils/type-matchers/index.tsx';

const SERVICE_ID_ATTRIBUTE_LABEL = 'Service ID';

export const extractEncodedServiceId = (
	attributes: InsightObjectAttribute[],
): string | undefined => {
	const serviceIdAttribute: DefaultAttribute | undefined = attributes.find(
		(att): att is DefaultAttribute =>
			matchInsightObjectAttribute(att, {
				default: (defaultAttribute) =>
					defaultAttribute.objectTypeAttribute.name.toLowerCase() ===
					SERVICE_ID_ATTRIBUTE_LABEL.toLowerCase(),
				object: () => false,
				user: () => false,
				group: () => false,
				project: () => false,
				status: () => false,
				bitbucketRepo: () => false,
				opsgenieTeam: () => false,
			}),
	);

	const serviceId = serviceIdAttribute?.defaultTypeValues[0].displayValue;

	if (serviceId != null) {
		return `b:${btoa(serviceId)}`;
	}

	return undefined;
};
